import { useContext } from "react";
import DataContext from "../context/dataProvider";
import {ContextState} from "../model/contextState";

export default function useData(): ContextState {
    return useContext(DataContext);
}